import "core-js/modules/es.array.find";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// import { mapActions} from "vuex"
import { loadMoreList, commonData } from "@/mixins/index";
import addPaymentIAAData from "./components/addPaymentIAAData";
import { MessageBox } from 'element-ui';
import { Message } from 'element-ui';
export default {
  name: "paymentIAAList",
  mixins: [loadMoreList, commonData],
  components: {
    addPaymentIAAData: addPaymentIAAData
  },
  data: function data() {
    return {
      pagingReqFn: "appIAATypeData",
      delIds: [],
      payData: '',
      tableBody: 'paymentIAAList'
    };
  },
  activated: function activated() {
    this.getcommonData(['appIAATypeAllData']);
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    payTypeChange: function payTypeChange(e) {
      if (e) {
        var data = this.appIAATypeAllData.find(function (i) {
          return i.id == e;
        });
        this.paramsData.iaa_type = data.iaa_type;
        this.paramsData.iaa_name = data.iaa_name;
      } else {
        this.paramsData.iaa_name = '';
        this.paramsData.iaa_type = '';
      }
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      }).toString(); // // let ids = dateList.map(item => { return item.id }).toString()
      // this.$store.dispatch('d2admin/method/deleteList', { req: 'appIAATypeDel ', data: { id: ids } }).then(() => {
      //   this.getList(this.paramsData.page);
      // })

      MessageBox.confirm("此操作将删除数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.$api.appIAATypeDel({
                  id: ids
                }).then(function (res) {
                  if (res.status == 200) {
                    Message({
                      type: "success",
                      message: "删除成功!"
                    });

                    _this.getList(_this.paramsData.page);
                  } else {}
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))).catch(function (err) {
        console.log("err", err);
      });
    }
  } // beforeRouteLeave(to, from, next) {
  //   this.getDataList('appPaymentTypeAllData')
  //   next()
  // },

};